import mediaQueries from "./media-queries";
import editor from "./editor";
import icons from "../imgs/icons";

const rightCol = {
  ...editor.rightCol,
  [mediaQueries.desktop]: {
    ...editor.rightCol[mediaQueries.desktop],
    marginTop: 0
  }
};

const preview = {
  ...editor.preview,
  transformStyle: "preserve-3d"
};

const textarea = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  zIndex: 1,
  background: "transparent",
  border: "none",
  lineHeight: 1.25,
  padding: 0,
  textAlign: "center",
  resize: "none",
  overflow: "hidden",
  "&:focus": {
    outline: "none"
  },
  '@media screen and (minWidth: 768px)': {
    boxSizing: "content-box",
    padding: "30px",
    border: "1px solid #D5C17D"
  }
};

const textValue = {
  ...textarea,
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  height: "auto",
  cursor: "pointer",
  transition: "color 0.1s ease-in-out",
  boxSizing: "content-box"
};

const overlay = {
  position: "fixed",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 1,
  [mediaQueries.tablet]: {
    position: "absolute"
  }
};

const buttons = {
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  margin: "30px 0 0 0",
  [mediaQueries.tablet]: {
    marginTop: 0
  }
};

const button = {
  // Longhand necessary for IE for some reason...
  flexGrow: 0,
  flexShrink: 0,
  width: "calc(50% - 7.5px)",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column"
};

const buttonTop = {
  backgroundColor: "#474747",
  padding: "20px 0",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "1 0 auto",
  [mediaQueries.tablet]: {
    padding: "25px 0"
  }
};

const buttonIcon = {
  maxHeight: "15px"
};

const buttonBottom = {
  backgroundColor: "#2F2F2F",
  width: "100%",
  textAlign: "center"
};

const buttonTitle = {
  fontFamily: "JWSansBold",
  fontSize: "13px",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "#D5C17D",
  width: "72%",
  display: "inline-block",
  margin: 0,
  borderBottom: "2px solid transparent",
  transition: "border-color 0.1s ease-in-out",
  lineHeight: 2.39
};

const fontPreview = {
  fontFamily: "JWSansBold",
  fontSize: "17px",
  color: "#D5C17D",
  lineHeight: "20px",
  letterSpacing: "2px",
  margin: 0
};

const ctaWrapper = {
  display: "flex",
  justifyContent: "flex-start",
  marginBottom: "13px",
  [mediaQueries.desktop]: {
    justifyContent: "space-between",
  }
};

const cta = {
  fontSize: "13px",
  textTransform: "uppercase",
  width: "calc(33% - 5px)",
  marginRight: "10px",
  border: "none",
  padding: 0,
  cursor: "pointer",
  [mediaQueries.desktop]: {
    width: "calc(50% - 4px)",
    marginRight: "0"
  }
};

const selectCta = {
  ...cta,
  padding: "2px 0",
  backgroundColor: "#ffffff",
  border: "2px solid #BB9959",
  opacity: "0.5",
  outline: "none"
};

const selectedCta = {
  ...selectCta,
  backgroundColor: "#BB9959",
  opacity: "1"
};

const mobileDone = {
  ...cta,
  marginRight: "0",
  [mediaQueries.desktop]: {
    display: "none"
  }
};

const ctaSpan = {
  lineHeight: 2.385,
  display: "block",
  width: "80%",
  margin: "0 auto",
  [mediaQueries.tablet]: {
    padding: "19px 0",
    lineHeight: 1
  }
};

const customiseOptions = {
  display: "flex",
  flexWrap: "wrap",
  cursor: "pointer",
  marginLeft: "-5px",
  marginRight: "-5px"
};

const customiseOption = {
  position: "relative",
  flex: "0 0 33.333333%",
  maxWidth: "33.333333%",
  paddingLeft: "5px",
  paddingRight: "5px",
  margin: "5px 0"
};

const customiseOptionColour = {
  ...customiseOption,
  height: "80px"
};

const customiseOptionColourSelected = {
  ...customiseOptionColour,
  border: "2px solid #BB9959",
  padding: "3px"
};

const activeColour = {
  background: `url(${icons.tick}) no-repeat`,
  width: "30px",
  height: "24px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const fontOption = {
  ...customiseOption,
  display: "flex",
  color: "#D5C17D",
  height: "80px",
  textAlign: "center",
};

const fontOptionSelected = {
  ...fontOption,
  border: "2px solid #BB9959",
  padding: "3px"
};

const fontFamilyWrapper = {
  background: "#D7D2CB",
  padding: "5px 0",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center"
};

const familyPreview = {
  color: "#000000",
  fontSize: "30px",
  letterSpacing: "0.05px",
  margin: 0,
  textAlign: "center",
  width: "100%"
};

const familyTitle = {
  color: "#000000",
  fontFamily: "JWSansBook",
  fontSize: "12px",
  letterSpacing: "0.45px",
  lineHeight: "20px",
  margin: 0,
  textAlign: "center",
  width: "100%"
};

const fontSliderWrapper = {
  position: "relative",
  margin: "15px 2% 35px",
  width: "100%",
  "&:before": {
    content: "''",
    position: "absolute",
    left: 0,
    top: "40px",
    width: "12px",
    height: "24px",
    background: `url(${icons.letterAIcon}) no-repeat`,
    backgroundSize: "12px 24px"
  },
  "&:after": {
    content: "''",
    position: "absolute",
    right: 0,
    top: "35px",
    width: "22px",
    height: "24px",
    background: `url(${icons.letterAIcon}) no-repeat`,
    backgroundSize: "22px 37px"
  }
};

const slider = {
  ...editor.slider,
  margin: 0
};

const desktopCta = {
  display: "none",
  [mediaQueries.tablet]: {
    display: "block"
  }
};

export default {
  rightCol,
  preview,
  textarea,
  textValue,
  overlay,
  buttons,
  button,
  buttonTop,
  buttonIcon,
  buttonBottom,
  buttonTitle,
  fontPreview,
  ctaWrapper,
  mobileDone,
  selectCta,
  selectedCta,
  ctaSpan,
  customiseOptions,
  customiseOption,
  customiseOptionColour,
  customiseOptionColourSelected,
  activeColour,
  fontSliderWrapper,
  fontOption,
  fontOptionSelected,
  fontFamilyWrapper,
  familyPreview,
  familyTitle,
  slider,
  desktopCta
};



// WEBPACK FOOTER //
// ./src/styles/text.js